import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { TSortingDirection } from './BaseTableHeaderCell';
import { useTheme } from '@material-ui/core';

type PSortIco = {
  className?: any;
  style?: any;
  direction?: TSortingDirection;
  isActive?: boolean;
};

const useStyles = makeStyles(() => ({
  ico: {
    transition: '300ms',
  },
  ico_desc: {
    transform: 'rotate(180deg)',
  },
}));

export const SortIco: React.FC<PSortIco> = (props) => {
  const { className, direction, isActive } = props;
  const classes = useStyles();
  const theme = useTheme();
  const currentColor = isActive ? theme.palette.primary.main : '#BEBEBE';
  return (
    <svg
      className={clsx(
        classes.ico,
        direction === 'desc' && classes.ico_desc,
        className,
      )}
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.77975 13.3555H7.63696C7.5588 13.3555 7.49468 13.3805 7.44443 13.4309C7.39432 13.4811 7.36914 13.5453 7.36914 13.6233V15.2304C7.36914 15.3088 7.39421 15.3727 7.44443 15.4231C7.49471 15.4732 7.5588 15.4983 7.63696 15.4983H9.77975C9.85791 15.4983 9.92212 15.4732 9.97216 15.4231C10.0225 15.3727 10.0473 15.3088 10.0473 15.2304V13.6233C10.0473 13.5453 10.0225 13.481 9.97216 13.4309C9.92212 13.3806 9.85791 13.3555 9.77975 13.3555Z"
        fill={currentColor}
      />
      <path
        d="M5.7624 12.2857H4.15526V0.767851C4.15526 0.689777 4.13022 0.625482 4.07997 0.575319C4.02972 0.525184 3.9656 0.5 3.88741 0.5H2.28024C2.20217 0.5 2.13787 0.525067 2.08771 0.575289C2.03761 0.62557 2.01242 0.689777 2.01242 0.767822V12.2856H0.405254C0.282586 12.2856 0.198854 12.3414 0.154173 12.453C0.109462 12.5591 0.129106 12.6567 0.212721 12.746L2.89126 15.4247C2.95266 15.4748 3.01678 15.4998 3.0838 15.4998C3.15633 15.4998 3.22057 15.4748 3.27633 15.4247L5.94652 12.7545C6.0024 12.6876 6.03025 12.6205 6.03025 12.5538C6.03025 12.4754 6.00507 12.4114 5.95496 12.3608C5.90474 12.3108 5.84062 12.2857 5.7624 12.2857Z"
        fill={currentColor}
      />
      <path
        d="M11.3869 9.07031H7.63696C7.5588 9.07031 7.49468 9.09538 7.44443 9.14554C7.3943 9.19571 7.36914 9.25991 7.36914 9.33796V10.9453C7.36914 11.0233 7.39421 11.0876 7.44443 11.1377C7.49468 11.1879 7.5588 11.2129 7.63696 11.2129H11.3869C11.4651 11.2129 11.5293 11.1879 11.5794 11.1377C11.6296 11.0875 11.6548 11.0233 11.6548 10.9453V9.33796C11.6548 9.25991 11.6296 9.19568 11.5794 9.14554C11.5293 9.09541 11.4651 9.07031 11.3869 9.07031Z"
        fill={currentColor}
      />
      <path
        d="M14.7947 0.575289C14.7444 0.525184 14.6803 0.5 14.6022 0.5H7.63794C7.55978 0.5 7.49566 0.525067 7.44541 0.575289C7.3953 0.62557 7.37012 0.689777 7.37012 0.767822V2.37499C7.37012 2.45315 7.39518 2.51727 7.44541 2.56752C7.49569 2.61763 7.55978 2.64281 7.63794 2.64281H14.6022C14.6803 2.64281 14.7444 2.61774 14.7947 2.56752C14.8449 2.51727 14.8699 2.45315 14.8699 2.37499V0.767851C14.87 0.689777 14.8449 0.625453 14.7947 0.575289Z"
        fill={currentColor}
      />
      <path
        d="M12.9951 4.78613H7.63794C7.55978 4.78613 7.49566 4.8112 7.44541 4.86148C7.39527 4.9117 7.37012 4.97582 7.37012 5.05401V6.66112C7.37012 6.73931 7.39518 6.80343 7.44541 6.85365C7.49566 6.90382 7.55978 6.929 7.63794 6.929H12.9951C13.0732 6.929 13.1374 6.90393 13.1878 6.85365C13.2378 6.80343 13.2629 6.73931 13.2629 6.66112V5.05401C13.2629 4.97582 13.2378 4.91159 13.1878 4.86148C13.1373 4.81132 13.0731 4.78613 12.9951 4.78613Z"
        fill={currentColor}
      />
    </svg>
  );
};
